<button class="button" [matMenuTriggerFor]="menu" [matBadge]="unreadNotificationsCount$ | async"
  [matBadgeHidden]="(unreadNotificationsCount$ | async) === 0" matBadgeSize="small">
  <mat-icon [ngClass]="{ 'new-notifications': (hasNewNotifications$ | async), ring: (ring$ | async) }"
    class="bell">notifications_none</mat-icon>
</button>
<mat-menu #menu="matMenu" xPosition="before" class="notification-menu">
  <div class="notification-menu__header">
    <p
      [innerHTML]="'NavbarNotifications.NewMessages' | translate : { count: unreadNotificationsCount$ | async } | safeHtml">
    </p>
  </div>
  <ul class="notification-menu__list">
    @for (notification of notifications$ | async; track notification.Id) {
    <li class="swipe-row">
      <div class="swipe-row__bg">
        <mat-icon class="swipe-row__icon">delete</mat-icon>
      </div>

      <div class="list-item swipe-row__front" [attr.data-id]="notification.Id"
        [ngClass]="{ 'list-item--new': !notification.IsRead }" (pointerdown)="swipeStart($event, notification)"
        (pointermove)="swipeMove($event, notification)" (pointerup)="swipeEnd($event, notification)"
        (pointercancel)="swipeCancel(notification)" (click)="onRowClick($event, notification)">
        <div class="list-item__image-wrapper">
          <img src="/assets/icons/notification/{{ notification.IconName }}" alt="" class="list-item__image"
            draggable="false" />
        </div>
        <div class="list-item__content">
          <div class="list-item__header">
            <div class="list-item__name">{{ notification.Title }}</div>
            <div class="list-item__date">{{ notification.Date | dateAgo }}</div>
          </div>
          <div class="list-item__body">
            {{ notification.Message | stripHtml }}
          </div>
        </div>
      </div>
    </li>
    }
  </ul>
  <div class="notification-menu__footer">
    @if (showLoadMore$ | async) {
    <div class="mat-select-button">
      <button mat-button (click)="loadMore($event)">{{ 'NavbarNotifications.ShowMore' | translate }}</button>
    </div>
    }
    @if (loadedCount$ | async; as loadedCount) {
    <div class="mat-select-footer">
      <span class="item-counter">{{ loadedCount }} {{ 'NavbarNotifications.Of' | translate }} {{ allCount$ | async
        }}</span>
    </div>
    }
  </div>
</mat-menu>